import {BRANDS, LOGIN_CASES} from 'const'
import {getDefaultConfig, getFavicon, getFooterLogosByBrandList, getHeaderLogo} from '../commonHelper'
import config from 'config'
import {NOTIFICATION_TYPES} from 'const/notifications'
import {FOOTER_LOGO_TYPES} from 'const/logos'

const REGULAR_FONT = '"Verlag Book", Helvetica, Arial, sans-serif'
const BOLD_FONT = '"Verlag Bold", Helvetica, Arial, sans-serif'
const TITLE_FONT = '"Superior Title", Helvetica, Arial, sans-serif'

const COLORS = {
  black: '#000000',
  ultraLight4: '#F7F7F7',
  darkGrey: '#292929',
  geyser: '#CDD5DB',
  white75: '#BFBFBF',
  white20: 'rgba(255, 255, 255, 0.2)',
  greyChateau: '#9BA5AD',
  white: '#FFFFFF',
  info: '#1A8BB8',
  success: '#1AB835',
  error: '#C4243B',
  warning: '#E8B620',
  almostBlack: '#212427',
}

const otherBrandsLogos = getFooterLogosByBrandList([
  BRANDS.autodesjahres,
  BRANDS.blick,
  `${BRANDS.schweizerillustrierte}-alpha`,
  BRANDS.illustre,
])
const BRAND_URL = `https://schweizer-auto-des-jahres.ch/`

export default {
  brand: {
    url: BRAND_URL,
    name: BRANDS.autodesjahres,
    favicon: getFavicon(BRANDS.autodesjahres),
    fontColor: COLORS.ultraLight4,
    support: 'https://schweizer-auto-des-jahres.ch/',
  },
  config: {
    ...getDefaultConfig(),
    useCircularSocialLogin: true,
    onePager: ({loginCase}) => [LOGIN_CASES.EMAIL_ONLY, LOGIN_CASES.DEFAULT].includes(loginCase),
    marketingOnePager: ({loginCase}) => [LOGIN_CASES.EMAIL_ONLY, LOGIN_CASES.DEFAULT].includes(loginCase),
    admeiraOptInOnePager: true,
    marketingConsent: true,
  },
  otherBrandsLogos,
  fontConfig: {custom: {urls: [`${config.url}/fonts/autodesjahres/index.css`]}},
  separator: {
    background: COLORS.greyChateau,
    color: COLORS.black,
    fontSize: '16px',
    height: '1px',
    lineHeight: '25px',
    transform: 'none',
    lineMarginTop: '0',
    margin: '48px 0 36px 0',
    portraitMargin: '48px 0 36px 0',
    landscapeMargin: '48px 0 36px 0',
    family: BOLD_FONT,
    fontWeight: 700,
  },
  shell: {
    body: {
      backgroundColor: COLORS.black,
    },
    header: {
      color: COLORS.ultraLight4,
      backgroundColor: COLORS.black,
      height: {
        default: '80px',
        onScroll: '56px',
        withEmail: '102px',
      },
      poweredLogo: {
        src: 'logo-onelog-poweredby-grey.png',
      },
      logo: {
        height: {
          default: '48px',
          small: '36px',
          onScroll: '36px',
        },
        src: {
          default: getHeaderLogo(BRANDS.autodesjahres),
          byLang: {
            fr: 'brands/autodesjahres/logo-fr.svg',
            it: 'brands/autodesjahres/logo-it.svg',
          },
        },
      },
      languageSwitcher: {
        color: COLORS.white,
        activeColor: COLORS.error,
        backgroundColor: COLORS.white,
        menu: {
          fontSize: '16px',
          lineHeight: '24px',
          color: COLORS.darkGrey,
          hoverBackgroundColor: COLORS.geyser,
        },
      },
      menu: {
        default: {
          color: COLORS.white,
          fontSize: '20px',
        },
        active: {
          color: COLORS.geyser,
          backgroundColor: COLORS.black,
          hoverBackgroundColor: COLORS.white,
          selectedBackgroundColor: COLORS.white,
          separatorColor: COLORS.greyChateau,
        },
      },
    },
    footer: {
      tenants: {
        logoColor: FOOTER_LOGO_TYPES.darkMode,
        color: COLORS.geyser,
        hoverColor: COLORS.white,
        backgroundColor: COLORS.darkGrey,
        fontSize: '16px',
        lineHeight: '24px',
        separatorColor: COLORS.geyser,
      },
      copyright: {
        brandNameColor: COLORS.geyser,
        color: COLORS.geyser,
        hoverColor: COLORS.white,
        backgroundColor: COLORS.black,
        fontSize: '16px',
        lineHeight: '24px',
        separatorColor: COLORS.geyser,
      },
    },
    loading: {
      backgroundColor: COLORS.black,
    },
  },
  ringierBanner: {
    backgroundColor: COLORS.darkGrey,
    fontSize: '18px',
    lineHeight: '26px',
    linkColor: COLORS.geyser,
    linkFontSize: '16px',
    linkHoverColor: COLORS.white,
    benefitMessageColor: COLORS.geyser,
    titleFontSize: '18px',
    titleColor: COLORS.geyser,
    landscape: {
      fontSize: '18px',
      titleFontSize: '18px',
    },
    titleFontWeight: '700',
    titleFontFamily: BOLD_FONT,
    onelogTitle: {
      fontSize: '16px',
      fontWeight: '700',
      lineHeight: '16px',
      color: COLORS.geyser,
      fontFamily: BOLD_FONT,
      margin: '0 0 20px 0',
    },
    onelogSection: {
      padding: '40px 0 0 0',
      borderTop: `1px solid ${COLORS.greyChateau}`,
    },
    onelogLogo: {
      src: '/assets/brands/onelog/greychateau/logo-onelog.svg',
      width: '94px',
      height: '20px',
    },
    benefitsIcon: `${config.url}/assets/brands/autodesjahres/icon-check-banner.svg`,
    padding: '20px',
    iconWidth: '24px',
    iconHeight: '24px',
    borderRadius: '4px',
  },
  font: {
    family: REGULAR_FONT,
    fontWeight: '400',
    boldFamily: BOLD_FONT,
    boldFontWeight: '700',
    size: '18px',
    height: '26px',
    mobile: {
      size: '18px',
      height: '26px',
    },
    portrait: {
      size: '18px',
      height: '26px',
    },
    color: {
      dark: COLORS.geyser,
      light: COLORS.geyser,
    },
  },
  logisterSection: {
    registerMarginTop: '25px',
    registerWeight: 400,
    registerSize: '16px',
    noteColor: COLORS.greyChateau,
    noteLineHeight: '24px',
    noteFontSize: {
      default: '18px',
      portrait: '18px',
    },
    subtitle: {
      hoverColor: COLORS.white,
      lineHeight: '26px',
      margin: '-12px 0 12px',
      fontSize: {
        default: '18px',
        portrait: '18px',
      },
      link: {
        color: COLORS.geyser,
        hoverColor: COLORS.white,
      },
    },
    title: {
      textChangeBreakpoint: 'mobile',
      fontSize: {
        smallMobile: '24px',
        mobile: '24px',
        portrait: '32px',
        landscape: '32px',
        desktop: '32px',
      },
      lineHeight: {
        smallMobile: '32px',
        mobile: '32px',
        portrait: '44px',
        landscape: '44px',
        desktop: '44px',
      },
    },
  },
  buttons: {
    height: '48px',
    primary: {
      border: `1px solid ${COLORS.white75}`,
      color: COLORS.black,
      background: COLORS.white75,
      hoverBorder: `1px solid ${COLORS.white}`,
      hoverBackground: COLORS.white,
      focusBorder: `2px solid ${COLORS.white}`,
      focusBackground: COLORS.white75,
      activeBorder: `1px solid ${COLORS.white}`,
      activeBackground: COLORS.white,
      isAnimated: true,
      textStyles: {
        family: BOLD_FONT,
        size: '18px',
        weight: 700,
      },
    },
    secondary: {
      border: `1px solid ${COLORS.white75}`,
      color: COLORS.white75,
      background: 'transparent',
      hoverColor: COLORS.white,
      hoverBorder: `1px solid ${COLORS.white}`,
      hoverBackground: 'transparent',
      focusColor: COLORS.white75,
      focusBorder: `2px solid ${COLORS.white}`,
      focusBackground: 'transparent',
      activeBorder: `1px solid ${COLORS.white}`,
      activeColor: COLORS.white,
      activeBackground: 'transparent',
      textStyles: {
        size: '18px',
        family: BOLD_FONT,
        weight: 700,
      },
      dotsColor: COLORS.white,
    },
    disabled: {
      border: `1px solid ${COLORS.white20}`,
      color: COLORS.white75,
      background: 'transparent',
      hoverBorder: `1px solid ${COLORS.white20}`,
      hoverBackground: 'transparent',
      activeBorder: `1px solid ${COLORS.white20}`,
      activeBackground: 'transparent',
      textStyles: {
        size: '18px',
        family: BOLD_FONT,
        weight: 700,
      },
    },
    touchId: {
      border: `1px solid ${COLORS.white75}`,
      color: COLORS.black,
      background: COLORS.white75,
      hoverBorder: `1px solid ${COLORS.white}`,
      hoverBackground: COLORS.white,
      focusBorder: `2px solid ${COLORS.white}`,
      focusBackground: COLORS.white75,
      activeBorder: `1px solid ${COLORS.white}`,
      activeBackground: COLORS.white,
      isAnimated: true,
      full: true,
      icon: 'brands/autodesjahres/icon-touchid.svg',
      activeIcon: 'brands/autodesjahres/icon-touchid.svg',
      iconStyles: {padding: '12px', marginLeft: '0'},
      textStyles: {
        size: '18px',
        family: BOLD_FONT,
        weight: 700,
      },
      descriptionStyles: {
        fontFamily: REGULAR_FONT,
        fontSize: '16px',
      },
    },
    faceId: {
      border: `1px solid ${COLORS.white75}`,
      color: COLORS.black,
      background: COLORS.white75,
      hoverBorder: `1px solid ${COLORS.white}`,
      hoverBackground: COLORS.white,
      focusBorder: `2px solid ${COLORS.white}`,
      focusBackground: COLORS.white75,
      activeBorder: `1px solid ${COLORS.white}`,
      activeBackground: COLORS.white,
      isAnimated: true,
      full: true,
      icon: 'brands/autodesjahres/icon-touchid.svg',
      activeIcon: 'brands/autodesjahres/icon-touchid.svg',
      iconStyles: {padding: '12px', marginLeft: '0'},
      textStyles: {
        size: '18px',
        family: BOLD_FONT,
        weight: 700,
      },
      descriptionStyles: {
        fontFamily: REGULAR_FONT,
        fontSize: '16px',
      },
    },
    anyId: {
      border: `1px solid ${COLORS.white75}`,
      color: COLORS.black,
      background: COLORS.white75,
      hoverBorder: `1px solid ${COLORS.white}`,
      hoverBackground: COLORS.white,
      focusBorder: `2px solid ${COLORS.white}`,
      focusBackground: COLORS.white75,
      activeBorder: `1px solid ${COLORS.white}`,
      activeBackground: COLORS.white,
      isAnimated: true,
      full: true,
      icon: 'brands/autodesjahres/icon-touchid.svg',
      activeIcon: 'brands/autodesjahres/icon-touchid.svg',
      iconStyles: {padding: '12px', marginLeft: '0'},
      textStyles: {
        size: '18px',
        family: BOLD_FONT,
        weight: 700,
      },
      descriptionStyles: {
        fontFamily: REGULAR_FONT,
        fontSize: '16px',
      },
    },
    icon: {
      height: '24px',
      width: '24px',
    },
    text: {
      family: REGULAR_FONT,
      boldFamily: BOLD_FONT,
      color: COLORS.black,
      size: '18px',
    },
    border: {
      radius: '4px',
    },
    linkOnSecondLine: true,
    dotsColor: COLORS.black,
  },
  title: {
    family: TITLE_FONT,
    size: '34px',
    height: '46px',
    margin: '0 0 24px 0',
    color: COLORS.geyser,
    mobile: {
      size: '26px',
      height: '35px',
    },
    portrait: {
      size: '34px',
      height: '46px',
    },
    weight: '700',
  },
  input: {
    borderRadius: '4px',
    background: COLORS.black,
    errorBackground: COLORS.black,
    color: COLORS.geyser,
    padding: '8px 12px',
    fontFamily: REGULAR_FONT,
    border: `1px solid ${COLORS.white75}`,
    errorBorder: `1px solid ${COLORS.error}`,
    hoverBorder: `1px solid ${COLORS.white}`,
    focusBorder: `1px solid ${COLORS.white}`,
    height: '48px',
    fontSize: '18px',
    email: {
      color: COLORS.greyChateau,
      backgroundColor: COLORS.black,
      fontSize: '18px',
      border: `1px solid ${COLORS.white75}`,
      borderRadius: '4px',
      button: {
        height: '32px',
        right: '12px',
        backgroundColor: COLORS.black,
        hoverBackgroundColor: COLORS.black,
        width: '70px',
        color: COLORS.white75,
        fontFamily: BOLD_FONT,
        fontSize: '16px',
        textDecoration: 'none',
        borderRadius: '4px',
        border: `1px solid ${COLORS.white75}`,
        borderRight: `1px solid ${COLORS.white75}`,
        hoverColor: COLORS.white,
        hoverBorder: `1px solid ${COLORS.white}`,
        hoverBorderRight: `1px solid ${COLORS.white}`,
      },
    },
    password: {
      color: COLORS.geyser,
      hoverColor: COLORS.white,
      size: '16px',
      height: '18px',
      top: '15px',
    },
    loading: {
      top: '7px',
    },
    placeholder: {
      color: COLORS.greyChateau,
      fontSize: '18px',
      lineHeight: '24px',
    },
  },
  field: {
    label: {
      color: COLORS.geyser,
      errorColor: COLORS.error,
      fontSize: '16px',
      bottomMargin: '6px',
      family: BOLD_FONT,
      disabledColor: COLORS.greyChateau,
      fontHeight: '16px',
      fontWeight: '600',
    },
    error: {
      background: 'inherit',
      fontColor: COLORS.error,
      size: '16px',
      height: '18px',
      padding: '0',
      margin: '12px 0 0',
    },
    optional: {
      fontSize: '16px',
      height: '16px',
      color: COLORS.geyser,
      family: REGULAR_FONT,
    },
    edging: {
      backgroundColor: COLORS.darkGrey,
    },
  },
  link: {
    default: COLORS.geyser,
    hoverColor: COLORS.white,
    infoHoverColor: COLORS.geyser,
    secondary: COLORS.geyser,
    secondaryHover: COLORS.white,
    isAgreementsLink: true,
    agreement: COLORS.geyser,
    textDecorationHover: 'underline',
    align: 'left',
    alignMobile: 'left',
  },
  secondaryFont: {
    size: '16px',
    height: '24px',
    mobile: {
      size: '16px',
      height: '24px',
    },
    portrait: {
      size: '16px',
      height: '24px',
      backlink: '16px',
    },
  },
  note: {
    family: REGULAR_FONT,
    lightFamily: REGULAR_FONT,
    fontSize: '18px',
    fontWeight: '400',
    lightFontWeight: '400',
    color: COLORS.geyser,
    termsText: {
      fontSize: '16px',
      lineHeight: '24px',
    },
    termsTitle: {
      fontFamily: BOLD_FONT,
      fontWeight: 600,
      fontSize: '16px',
      lineHeight: '24px',
      margin: '0',
    },
  },
  notification: {
    family: '',
    success: COLORS.success,
    error: COLORS.error,
    pageError: COLORS.error,
    warning: COLORS.warning,
    info: COLORS.info,
    icon: {
      width: '24px',
      height: '24px',
      mobile: {
        width: '32px',
        height: '32px',
      },
    },
    pageMessage: {
      size: '18px',
      height: '26px',
      sizeMobile: '18px',
      heightMobile: '26px',
      colorFunc: type => {
        switch (type) {
          case NOTIFICATION_TYPES.warning:
            return COLORS.almostBlack
          case NOTIFICATION_TYPES.error:
          case NOTIFICATION_TYPES.success:
          case NOTIFICATION_TYPES.info:
          default:
            return COLORS.white
        }
      },
    },
  },
  form: {
    border: '',
    background: COLORS.darkGrey,
    fieldBackground: '',
    padding: '0 0 24px 0',
    marginBottom: '0',
    loginSubmitMarginTop: 16,
    note: {
      fontSize: '18px',
      lineHeight: '27px',
      fontFamily: TITLE_FONT,
    },
  },
  logisterForm: {
    border: '',
    background: '',
    padding: '28px 0 0 0',
    submitButton: 'primary',
    submitButtonMargin: '36px 0 0 0',
    forgetLinkFloat: 'right',
  },
  loginForm: {
    submitButtonMargin: 36,
    title: {
      margin: '0 0 48px',
    },
    forgetLink: {
      wrapper: {
        defaultMarginBottom: '20px',
        errorMarginBottom: '22px',
      },
      link: {
        fontSize: '16px',
        color: COLORS.geyser,
      },
    },
  },
  registerPage: {
    backLinkMargin: {
      default: '0 0 24px',
      portrait: '0 0 24px',
    },
    titleMargin: {
      default: '0 0 24px',
      portrait: '0 0 24px',
    },
    submitButtonMarginTop: 12,
    subtitle: {
      fontFamily: TITLE_FONT,
      fontSize: '18px',
      lineHeight: '27px',
      margin: '0 0 48px',
      fontWeight: '700',
      color: COLORS.geyser,
    },
  },
  resetPasswordPage: {
    subtitle: {
      fontSize: '18px',
      lineHeight: '26px',
      margin: '0 0 36px 0',
    },
  },
  emailVerifyPage: {
    noteMarginTop: '24px',
    linkMarginBottom: '12px',
    adjustNoteMarginBottom: '48px',
    subtitleFontSize: '18px',
    note: {
      fontFamily: BOLD_FONT,
      fontSize: '18px',
    },
    link: {
      color: COLORS.geyser,
      fontSize: '18px',
    },
    subtitle: {
      fontFamily: TITLE_FONT,
    },
    message: {
      margin: '0 0 24px 0',
    },
    pageMessageMarginTop: '36px',
    pageMessageMarginBottom: '48px',
  },
  textarea: {
    height: '96px',
  },
  checkbox: {
    icon: {
      height: '20px',
      width: '20px',
      top: '0px',
      right: '12px',
      image: 'brands/autodesjahres/form/checkbox.svg',
      checkedImage: 'brands/autodesjahres/form/checkbox-checked.svg',
      hoverImage: 'brands/autodesjahres/form/checkbox-hover.svg',
      errorImage: 'brands/autodesjahres/form/checkbox-error.svg',
      disabledImage: 'brands/autodesjahres/form/checkbox-disabled.svg',
    },
    errorMargin: '',
    padding: '16px 20px',
    labelFontHeight: '21px',
    labelColor: COLORS.geyser,
    fontSize: '16px',
    group: {
      label: {
        marginBottom: '8px',
        padding: '0',
        backgroundColor: '',
      },
      marginBottom: '20px',
      padding: '0 20px',
      backgroundColor: COLORS.white,
      fontWeight: '600',
      family: BOLD_FONT,
      fontSize: '16px',
      note: {
        fontWeight: '300',
        fontSize: '16px',
        marginLeft: '32px',
        color: COLORS.geyser,
      },
    },
    errorPadding: '4px 20px 0',
  },
  select: {
    fontFamily: REGULAR_FONT,
    icon: {
      width: '16px',
      height: '16px',
      image: 'brands/autodesjahres/icon-arrow-down.svg',
      focusImage: 'brands/autodesjahres/icon-arrow-down-active.svg',
      alt_image: 'brands/autodesjahres/icon-arrow-down.svg',
    },
    menu: {
      border: `1px solid ${COLORS.white75}`,
      isCheckIconVisible: false,
      checkIcon: 'NRJ-check-form-grey.svg',
      color: COLORS.geyser,
      option: {
        color: COLORS.geyser,
        fontFamily: REGULAR_FONT,
        fontSize: '18px',
        padding: '4px 20px',
        focusBorder: '0',
        focusBackground: COLORS.darkGrey,
        focusColor: COLORS.geyser,
        selectedFontFamily: BOLD_FONT,
      },
      placeholder: {
        color: COLORS.greyChateau,
      },
      singleValue: {
        color: COLORS.geyser,
      },
      list: {
        backgroundColor: COLORS.black,
      },
    },
    dropdownIndicator: {
      padding: '0',
    },
  },
  radio: {
    icon: {
      width: '20px',
      height: '20px',
      image: 'brands/autodesjahres/form/radio.svg',
      checkedImage: 'brands/autodesjahres/form/radio-active.svg',
      hoverImage: 'brands/autodesjahres/form/radio-hover.svg',
      errorImage: 'brands/autodesjahres/form/radio-error.svg',
      disabledImage: 'brands/autodesjahres/form/radio-disabled.svg',
    },
    errorMargin: '12px 0 0',
    labelFontHeight: '28px',
    labelMarginBottom: '8px',
    fontSize: '16px',
    fontFamily: REGULAR_FONT,
    fontWeight: 400,
    color: COLORS.geyser,
  },
  errorPage: {
    font: {
      height: '18px',
      portrait: {
        height: '26px',
      },
    },
  },
  inputNote: {color: COLORS.geyser, size: '16px', height: '18px', marginTop: '12px'},
  tab: {
    fontSize: '16px',
    desktop: {focusBorder: `solid 4px ${COLORS.black}`, bottomMargin: '-4px', height: '80px'},
    mobile: {icon: {border: `solid 2px ${COLORS.black}`, width: '14px', height: '14px', color: COLORS.geyser}},
  },
  consent: {
    subtitle: {
      marginBottom: '12px',
      fontFamily: TITLE_FONT,
      fontSize: '18px',
      color: COLORS.geyser,
    },
    checkbox: {
      marginBottom: '20px',
      paddingBottom: '',
    },
    agreements: {
      fontSize: '16px',
    },
  },
  mobileNumber: {
    label: {
      marginBottom: '20px',
    },
    subtitle: {
      marginTop: '8px',
      color: COLORS.geyser,
      family: REGULAR_FONT,
      fontSize: '18px',
    },
    select: {
      padding: '8px 0px 8px 12px',
      backgroundColor: COLORS.darkGrey,
      borderRight: `1px solid ${COLORS.white75}`,
      hoverBorderRight: `1px solid ${COLORS.white}`,
      focusBorderRight: `1px solid ${COLORS.white}`,
      errorBorderRight: `1px solid ${COLORS.error}`,
    },
    selectIcon: {
      padding: '0px 12px',
    },
    input: {
      backgroundColor: COLORS.black,
      errorBackgroundColor: COLORS.black,
      padding: '8px 12px',
    },
    code: {
      letterSpacing: '14px',
      paddingLeft: {
        normal: 'calc(50% - 50px)',
        error: 'calc(50% - 51px)',
      },
      underline: {
        left: 'calc(50% - 20px)',
        top: 'calc(50% - 7px)',
      },
    },
    questionLabel: {
      family: BOLD_FONT,
      color: COLORS.geyser,
      fontSize: '16px',
    },
    link: {
      fontSize: '18px',
      lineHeight: '18px',
      fontFamily: REGULAR_FONT,
    },
    verifiedLabel: {
      color: COLORS.geyser,
    },
    container: {
      marginBottom: '15px',
    },
  },
  address: {
    padding: '20px 20px 0px 20px',
    inputBackgroundColor: COLORS.black,
    formFieldMarginBottom: '',
    checkboxPadding: '0px 0px 20px 0px',
    link: {
      fontSize: '16px',
      lineHeight: '24px',
    },
    control: {
      fontSize: '18px',
      fontFamily: REGULAR_FONT,
      lineHeight: '26px',
    },
  },
  mfa: {
    backButtonFontSize: '16px',
    inputPadding: '12px',
    subtitleFontSize: '18px',
    textFontSize: '18px',
    title: {
      margin: '0 0 48px',
    },
    link: {
      color: COLORS.geyser,
      hoverColor: COLORS.white,
      margin: '0 0 12px',
    },
  },
  edging: {
    borderRadius: '4px',
    backgroundColor: COLORS.darkGrey,
  },
  webauthn: {
    dropdown: {
      color: COLORS.geyser,
      hoverColor: COLORS.white,
      fontSize: '18px',
    },
    logisterForm: {
      marginBottom: '16px',
    },
    setup: {
      title: {
        margin: '0 0 12px',
      },
      description: {
        margin: '0 0 12px',
      },
      text: {
        margin: '0 0 16px',
      },
    },
  },
  emailVerifiedPage: {
    subtitle: {
      fontFamily: BOLD_FONT,
      fontSize: '18px',
      margin: '0 0 36px 0',
      color: COLORS.geyser,
    },
  },
  languageSwitcher: {
    menuColor: COLORS.white,
    menuIcon: 'OL-icon-arrow-down-white.svg',
    profileMenuIcon: 'OL-icon-arrow-down-white.svg',
    profileMenuColor: COLORS.white,
    listItemHoverColor: COLORS.geyser,
    listItemActiveColor: COLORS.black,
    switcherListBorder: '1px solid #CDD5DB',
  },
}
